import { ToolbarStorage } from '@/features/dev-toolbar';
import { isProdBuildMode } from '#shared/helpers/buildMode';

export const CAPTCHA_SITE_KEY_PROD = 'ysc1_ZC61D4fdkfa62evG6MTf953oALF74vAOIyCGxnbIadbe8a72';
export const CAPTCHA_SITE_KEY_DEV = 'ysc1_gnmiRIRkktsqatDYyWnUlts8b0b7m2aJDDmChrQo2df91cee';

export function createCaptcha(
  containerId: string,
  onCaptchaSuccess: (token: string) => void,
  repeatCount = 0
) {
  // @ts-ignore
  if (!window.smartCaptcha) {
    if (repeatCount > 10) {
      return;
    }
    setTimeout(() => {
      createCaptcha(containerId, onCaptchaSuccess, repeatCount + 1);
    }, 100);
    return;
  }

  const container = document.getElementById(containerId);
  const CAPTCHA_SITE_KEY = getCaptchaSiteKey();

  // @ts-ignore
  window.smartCaptcha.render(container, {
    sitekey: CAPTCHA_SITE_KEY,
    hl: 'ru',
    callback: onCaptchaSuccess,
  });
}

function getCaptchaSiteKey() {
  if (isProdBuildMode()) return CAPTCHA_SITE_KEY_PROD;

  const restEnvStore = ToolbarStorage.getStorageToolbarField('restEnv');
  if (restEnvStore === 'production') {
    return CAPTCHA_SITE_KEY_PROD;
  }

  return CAPTCHA_SITE_KEY_DEV;
}
